import makeStyles from '@mui/styles/makeStyles';

interface Props {
  block?: boolean;
  bordercolor?: string;
  disabled?: boolean;
}
const styles = makeStyles(() => ({
  borderDiv: {
    "&:hover": {
      borderColor: (props: Props) => (!props?.disabled ? props?.bordercolor : "#C4C4C4"),
    },
    border: "1px solid #C4C4C4",
    height: "40px",
    width: (props: Props) => (props.block ? "100%" : "auto"),
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
  },
  button: {
    padding: "0px",
    marginLeft: "10px",
  },
}));

export default styles;
